/**
 * Traverses a tree in breadth-first order, yielding nodes level by level.
 */
export class BreadthFirstTreeTraverser<T> {
  getChildren: (node: T) => Promise<T[]>;

  childToParentMap: Map<T, T | null> = new Map();

  constructor(getChildren: (node: T) => Promise<T[]>) {
    this.getChildren = getChildren;
  }

  getChildToParentMap(): ReadonlyMap<T, T | null> {
    return this.childToParentMap;
  }

  async *traverseLevel(topLevelNodes: T[]): AsyncGenerator<T[]> {
    let queue: T[] = [...topLevelNodes];
    const visited = new Set<T>();
    this.childToParentMap.clear();

    for (const node of topLevelNodes) {
      this.childToParentMap.set(node, null);
    }

    while (queue.length > 0) {
      const currentLevel = [...queue];
      queue = [];
      yield currentLevel;

      for (const node of currentLevel) {
        visited.add(node);
        const children: T[] = await this.getChildren(node);
        for (const child of children) {
          if (!visited.has(child)) {
            queue.push(child);
            if (!this.childToParentMap.has(child)) {
              this.childToParentMap.set(child, node);
            }
          }
        }
      }
    }
  }
}
